import { useDataModel } from '@thd-nucleus/data-sources';
import { activeOrdersDataModel, ActiveOrdersQueryVariables } from './activeOrdersDataModel';
import { RawActiveOrdersResponse } from './types';
import { QueryResult, toQueryResult } from './queryResult';

export interface UseActiveOrdersQueryOptions {
  skip?: boolean;
}

export function useActiveOrdersQuery(
  variables: ActiveOrdersQueryVariables,
  { skip = false }: UseActiveOrdersQueryOptions = {}
): QueryResult<RawActiveOrdersResponse> {
  const response = useDataModel('activeOrders', {
    variables,
    dataModel: activeOrdersDataModel,
    skip,
    context: { withAuth: true }
  });

  // useDataModel returns Apollo's raw useQuery response, keyed by query name
  // (response.data === { activeOrders: RawActiveOrdersResponse }) — unwrap it here so every
  // caller of this hook works with the response shape directly.
  return toQueryResult<RawActiveOrdersResponse>({ ...response, data: response.data?.activeOrders }, skip);
}
